exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.timeline {\n  box-sizing: border-box;\n  position: absolute;\n  top: 0px;\n\n  background-color: #FFFFFF;\n  opacity: 0.2;\n\n  border-right-style: solid;\n  border-right-color: #cccccc;\n  border-right-width: 1px;\n\n  z-index: 999;\n}\n.timeline:hover {\n  background-color: #fff3ba;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-dc4509c2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/SpTimeline.vue
// module id = 549
// module chunks = 0